module.exports = __webpack_public_path__ + "media/images/png/rent/5-382c0617edc43e57638e26416dd31e6c.png";